module.exports = __webpack_public_path__ + "img/wordpress-icon.ee57ad49.svg";